"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChannelData = void 0;
var utils_1 = require("./utils");
var react_1 = __importStar(require("react"));
var initialState = {
    messages: [],
    loadingEarlier: false,
    loadingLater: false,
    hasMoreEarlier: false,
    liveUpdate: true,
    channel: undefined,
    actingUsers: [],
    unreadMessageCount: 0,
};
var reducer = function (state, action) {
    if (action.type === 'update') {
        var channelMessageStorage = action.chatService.channelMessageStorage(action.channelId);
        var data = __assign(__assign({}, state), channelMessageStorage.state());
        if (action.channel)
            data = __assign(__assign({}, data), { channel: action.channel });
        return data;
    }
    else if (action.type === 'update-acting-users') {
        return __assign(__assign({}, state), { actingUsers: action.actingUsers });
    }
    else if (action.type === 'update-unread-status') {
        return __assign(__assign({}, state), { lastReadMessageId: action.lastReadMessageId, unreadMessageCount: action.unreadMessageCount || 0 });
    }
    return state;
};
var useChannelData = function (channelExternalId, chatService) {
    var _a, _b;
    var _c = react_1.default.useReducer(reducer, initialState), state = _c[0], dispatch = _c[1];
    var _d = react_1.default.useState([]), currentUnsubscriptions = _d[0], setCurrentUnsubscriptions = _d[1];
    var loadEarlier = react_1.useCallback(function () {
        if (state.channel)
            chatService.loadEarlier(state.channel.id);
    }, [state.channel, chatService]);
    var loadLater = react_1.useCallback(function () {
        if (state.channel)
            chatService.loadLater(state.channel.id);
    }, [state.channel, chatService]);
    // let websocket listen to channel messages and subscribe to new new messages
    react_1.default.useEffect(function () {
        var _a;
        function subscribeToChannel() {
            return __awaiter(this, void 0, void 0, function () {
                var channel, channelMessageStorage, removeListener, unsubscribeChannel;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, chatService.getChannelByExternalId(channelExternalId)];
                        case 1:
                            channel = _a.sent();
                            channelMessageStorage = chatService.channelMessageStorage(channel.id);
                            removeListener = channelMessageStorage.onUpdate(function () {
                                dispatch({
                                    type: 'update',
                                    channelId: channel.id,
                                    chatService: chatService,
                                });
                            });
                            unsubscribeChannel = chatService.subscribeChannel(channel.id);
                            setCurrentUnsubscriptions([removeListener, unsubscribeChannel]);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (((_a = state.channel) === null || _a === void 0 ? void 0 : _a.externalId) !== channelExternalId ||
            currentUnsubscriptions.length === 0) {
            // unsubscribe from previous channels
            currentUnsubscriptions.forEach(function (cb) { return cb(); });
            subscribeToChannel();
        }
        return function () {
            currentUnsubscriptions.forEach(function (cb) { return cb(); });
            setCurrentUnsubscriptions([]);
        };
    }, [chatService, channelExternalId]);
    //fetch channel and listen for future channel updates
    react_1.default.useEffect(function () {
        var channelStorage = chatService.getChannelStorage();
        chatService
            .getChannelByExternalId(channelExternalId)
            .then(function (_channel) { return __awaiter(void 0, void 0, void 0, function () {
            var currentUser;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, chatService.currentUser()];
                    case 1:
                        currentUser = _c.sent();
                        dispatch({
                            type: 'update-unread-status',
                            lastReadMessageId: (_b = (_a = _channel.channelMemberships) === null || _a === void 0 ? void 0 : _a.find(function (cm) { return cm.userId === currentUser.id; })) === null || _b === void 0 ? void 0 : _b.lastReadMessageId,
                            unreadMessageCount: _channel.unreadMessageCount,
                            chatService: chatService,
                            channelId: _channel.id,
                        });
                        dispatch({
                            type: 'update',
                            channelId: _channel.id,
                            chatService: chatService,
                            channel: _channel,
                        });
                        chatService.setCurrentActiveChannel(_channel);
                        chatService.markAllAsRead(_channel.id);
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) {
            //TODO: Failed to load channel(due to server error)
            //Show error to user
            console.error('Failed Loading channel', error);
        });
        var removeListener = channelStorage.onUpdate(function (data) {
            if (data &&
                data.channel &&
                data.channel.externalId === channelExternalId) {
                dispatch({
                    type: 'update',
                    channelId: data.channel.id,
                    chatService: chatService,
                    channel: data.channel,
                });
                chatService.setCurrentActiveChannel(data.channel);
            }
        });
        return function () {
            chatService.setCurrentActiveChannel(null);
            removeListener();
        };
    }, [channelExternalId, chatService]);
    react_1.default.useEffect(function () {
        function checkTypingUsers() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function () {
                var currentUser, actingUsers;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, chatService.currentUser()];
                        case 1:
                            currentUser = _c.sent();
                            actingUsers = (_b = (_a = state.channel) === null || _a === void 0 ? void 0 : _a.channelMemberships) === null || _b === void 0 ? void 0 : _b.filter(function (memberShip) {
                                return memberShip.userId !== (currentUser === null || currentUser === void 0 ? void 0 : currentUser.id) &&
                                    memberShip.lastActingAt &&
                                    utils_1.diffInSeconds(new Date(), new Date(memberShip.lastActingAt)) < 20;
                            }).map(function (memberShip) { return (__assign(__assign({}, memberShip.user), { actingType: memberShip.lastActiingType })); });
                            if (actingUsers) {
                                dispatch({
                                    type: 'update-acting-users',
                                    actingUsers: actingUsers,
                                    chatService: chatService,
                                    channelId: state.channel.id,
                                });
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        var intervalId = setInterval(function () {
            checkTypingUsers();
        }, 10 * 1000);
        checkTypingUsers();
        return function () {
            clearInterval(intervalId);
        };
    }, [
        (_b = (_a = state.channel) === null || _a === void 0 ? void 0 : _a.channelMemberships) === null || _b === void 0 ? void 0 : _b.filter(function (memberShip) {
            return memberShip.lastActingAt &&
                utils_1.diffInSeconds(new Date(), new Date(memberShip.lastActingAt)) < 20;
        }).length,
    ]);
    return [state, loadEarlier, loadLater];
};
exports.useChannelData = useChannelData;
//# sourceMappingURL=useChannelData.js.map